import { Api, queryClient, queryKeys } from '@/infrastructure';
import { useMutation, UseMutationResult } from 'react-query';
import snakecaseKeys from 'snakecase-keys';

export const useUpdateDirectScheduleAdjustmentMutation = (token: string): UseMutationResult => {
  return useMutation(
    ({
      orderId,
      contactName,
      contactPhoneNumber,
      mechanicParkingPlace,
      comment,
      preferredTimeframeStart,
      preferredTimeframeEnd,
      referenceFiles
    }: {
      orderId: string;
      contactName?: string;
      contactPhoneNumber?: string;
      mechanicParkingPlace: string;
      comment?: string;
      preferredTimeframeStart: string;
      preferredTimeframeEnd: string;
      referenceFiles?: Array<{
        file_key: string;
      }>;
    }) => {
      return Api.patch({
        path: `direct_schedule_adjustments/${token}/orders/${orderId}`,
        data: {
          direct_schedule_adjustment_order: snakecaseKeys({
            contactName,
            contactPhoneNumber,
            mechanicParkingPlace,
            comment,
            preferredTimeframeStart,
            preferredTimeframeEnd,
            referenceFiles
          })
        }
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.directScheduleAdjustment, token]);
      }
    }
  );
};

export const useCancelDirectScheduleAdjustmentMutation = (token: string): UseMutationResult => {
  return useMutation(
    ({ orderId }: { orderId: string }) => {
      return Api.patch({
        path: `direct_schedule_adjustments/${token}/orders/${orderId}/cancel`,
        data: {}
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.directScheduleAdjustment, token]);
      }
    }
  );
};

export const useUpdateAddressDirectScheduleAdjustmentMutation = (token: string): UseMutationResult => {
  return useMutation(
    ({ orderId, address }: { orderId: string; address: string }) => {
      return Api.patch({
        path: `direct_schedule_adjustments/${token}/orders/${orderId}/update_address`,
        data: {
          address
        }
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.directScheduleAdjustment, token]);
      }
    }
  );
};

export const useOldUpdateDirectScheduleAdjustmentMutation = (token: string): UseMutationResult => {
  return useMutation(
    ({
      orderId,
      preferredTime,
      contactName,
      contactPhoneNumber,
      mechanicParkingPlace,
      address,
      comment
    }: {
      orderId: string;
      preferredTime: string;
      contactName?: string;
      contactPhoneNumber?: string;
      mechanicParkingPlace: string;
      address: string;
      comment: string;
    }) => {
      return Api.patch({
        path: `direct_schedule_adjustments/${token}/orders/${orderId}`,
        data: {
          direct_schedule_adjustment_order: snakecaseKeys({
            preferredTime,
            contactName,
            contactPhoneNumber,
            mechanicParkingPlace,
            address,
            comment
          })
        }
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.directScheduleAdjustment, token]);
      }
    }
  );
};
